import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksAccountLineItemsSection', {
    accountColumnName: 'Category',
    descriptionColumnName: 'Description',
    amountColumnName: 'Amount {currency}',
    taxColumnName: 'Tax',
    customerColumnName: 'Customer',
    classColumnName: 'Class',
    billableColumnName: 'Billable',
    taxableColumnName: 'Tax',
    billableColumnTooltip: 'This line is billable',
    taxableColumnTooltip: 'This line is taxable',
    linkedColumnName: 'Linked',
    matching: 'Link',
    sectionHeaderText: 'Category Details',
});
